/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "backbone",
  "client/template",
  "client/templateregistry",
  "component!base",
  "i18n/i18n",
  "underscore",
  "jquery",
  "utils/dom",
  "editors/adder/js/model"
], function (
  Backbone,
  Template,
  TemplateRegistry,
  ComponentBase,
  i18n,
  _,
  $,
  dom,
  AdderGroups
) {

  var TemplateModule = Template.extend({

    editableName: "editor_360",

    initialize: function (node, tree) {
      var that = this;
      this.moduleEl = this.el
      if (this.moduleEl) {
        this.editableType = this.moduleEl.getAttribute('data-app-fragment-ref-type');
        this.editableName = this.moduleEl.getAttribute('data-app-fragment-ref-name');
      }
      
      // not adding it directly
      if (!this.el.schemaData) {
        var application = this.application;
        var appFragmentStore = this.application.getAppFragmentStore();
        //TODO: we need a syncron call here!
        appFragmentStore.getByTypeAndName(this.editableType, this.editableName).then(function (appFragmentJson) {
          var schema = new Template.Schema(appFragmentJson.schema);
          Object.defineProperty(that, "schema", {
            writeable: false,
            get: function () {
              return schema;
            }
          });
        })
        
        // get the schema from the persisted collections
      } else {
        var schema = new Template.Schema(this.el.schemaData);
        Object.defineProperty(this, "schema", {
          writeable: false,
          get: function () {
            return schema;
          }
        });
      }
      
      this.attributeModel = new dom.AttributeModel(this.moduleEl, "data-");
      Template.prototype.initialize.apply(this, arguments);
      // the app fragment reference itself should be editable
      // this.editable = true;
    },

    hasContent: function () { return true },

    getContentSchema: function () {
      return {
        type: "template"
      };
    },

    getOptions: function (options) {
      options = _.extend(
        {},
        Template.prototype.getOptions.apply(this, arguments),
        this.attributeModel.getCamelCase()
      );
      //TODO: if appfragmentStore call finishes too late then this.schema is undefined 
      return this.schema && this.schema.parseAttributes(options) ||  (new Template.Schema(this.el.schemaData)).parseAttributes(options);
    },

    remove: function (options) {
      var nodesToRemove = [];
      for (var i = 0; i < this.el.childNodes; ++i) {
        if (this.el.childNodes[i] != this.moduleEl) {
          nodesToRemove.push(this.el.childNodes[i]);
        }
      }
      _.each(nodesToRemove, function (node) {
        node.parentNode.removeChild(node);
      });
    }

  });


  TemplateModule.View = ComponentBase.extend({

    initialize: function () {
      ComponentBase.prototype.initialize.apply(this, arguments);
    }
  });


  var AdderGroup = function () { };

  _.extend(AdderGroup.prototype, Backbone.Events, {
    id: "module",
    name: 'editor_modules',
    weight: 4,
    list: [],
    promiseCompleted: false,

    getAdders: function (model, application) {
      if (application.options.experimentalUseModulesInDesigner !== true) {
        return;
      }

      var that = this;
      var appFragmentStore = application.getAppFragmentStore();
 
      this.promise = appFragmentStore.getAllAppDescriptions(undefined, { application: application });
      if (!this.promiseCompleted) {
        this.promise.then(function (response) {
          that.list = response;

          that.promiseCompleted = true;
          that.trigger("changed", this);
        });
      }

      return this.groupAppFragmentList(this.list);
    },

    groupAppFragmentList: function (list) {
      var mappedList = list.reduce(function (accumulator, fragment) {
        if (!accumulator[fragment.type]) {
          accumulator[fragment.type] = [];
        }
        accumulator[fragment.type].push(fragment);
        return accumulator;
      }, {});

      var grouped = _.map(mappedList, function (fragments) {
        var childrenList = fragments.map(function (fragment) {

          return {
            appFragment: fragment,
            templateType: "module",
            name: fragment.name,
            label: fragment.name,
            // this is passed to the create function
            options: {
              name: fragment.name,
              attributes: {
                type: 'app-fragment',
                appFragmentRefType: fragment.type,
                appFragmentRefName: fragment.name
              },
              schema: fragment.schema
            }
          }
        });

        return {
          group: fragments[0].type,
          id: fragments[0].type,
          localizedName: fragments[0].type,
          label: fragments[0].type,
          children: new AdderGroups.Adders(childrenList),
          toggleOpen: true
        }
      });

      if (grouped.length) {
        return grouped;
      }

      // @todo translate these labels, when no module found
      // This is to make shure the user is able to see the Modules tab if no initial modules found
      return [
        {
          group: 'basic',
          id: 'basic',
          localizedName: 'basic',
          children: [],
          label: 'basic'
        }
      ]
    },

    create: function (options) {
      var schema = new Template.Schema();
      options = options || {};
      var refChildEl = document.createElement("div");
      _.forEach(options.attributes || {}, function (value, key) {
        refChildEl.setAttribute("data-" + dom.AttributeModel.camelCaseToSeparated(key), schema.serializeAttribute(value, key));
      });
      return refChildEl;
    }
  });

  TemplateRegistry.add(new AdderGroup());

  return TemplateModule;
});

